import * as React from 'react'

import { SITE } from 'modules/urls'

import {
  isGenericEmail,
} from './helpers'

// These are to be moved to the utils repository in the future for clean reuse
const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const isValidRequiredEmail = (value) => {
  if (!value) return 'Please enter a valid email address.'
  if (!emailRegEx.test(value)) return 'Invalid email address.'
  if (isGenericEmail(value)) {
    return (
      <>
        We&apos;ve detected that you&apos;re using a personal email address.
        Please use your professional email address.
        {' '}
        If you are looking to apply as an AI Trainer, please visit the
        {' '}
        <a href={SITE.AI_TRAINER}>AI Trainer application page</a>
        .
      </>
    )
  }
  return ''
}
export const isNotEmpty = (value) => {
  let error = ''
  if (!value || value?.length === 0) {
    error = 'This field is required'
  }
  return error
}

export const validateMultipleChoice = (value) => {
  let error = ''
  if (value?.length === 0) {
    error = 'Please select at least one of the options.'
  }
  return error
}

export const validateSingleChoice = (value) => {
  let error = ''
  if (value?.length === 0) {
    error = 'Please select one of the options.'
  }
  return error
}

export const validateOtherGoal = (value) => {
  let error = ''
  if (!value) {
    error = 'Please tell us about your goals.'
  }
  return error
}

export const validateFullName = (value) => {
  if (!value) return 'Please enter your full name.'
  return ''
}

export const validateCompanyName = (value) => {
  if (!value) return 'Please enter your company name.'
  return ''
}

export const validateReferrerName = (value) => {
  if (!value) return 'Please enter your referrer\'s name.'
  return ''
}

export const validateOtherReferrer = (value) => {
  if (!value) return 'Please share the details of how you found us.'
  return ''
}

export const validateOtherRole = (value) => {
  if (!value) return 'Please add details about your role.'
  return ''
}

export const validateOtherPlatform = (value) => {
  if (!value) return 'Please add details about your platform.'
  return ''
}
